'use client';
import React, { useEffect, useRef, useState } from 'react';
import './Index.css';
import {
  Paper,
  Stack,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { useStore } from '../../../utils/store';
import { useNavigate, useParams } from 'react-router-dom';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import DeleteIcon from '@mui/icons-material/Delete';
import ButtonComponent from '../../../components/form/ButtonComponent';
import SimpleAutoCompleteTextFieldComponent from '../../../components/form/SimpleAutoCompleteTextFieldComponent';
import SimpleDialogComponent from '../../../components/SimpleDialogComponent';
import IdLabelData from '../../../Models/IdLabelData';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import FormFieldData from '../../../Models/FormFieldData';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';
import { formatPrice, formatPriceSmart } from '../../../utils/storageUtil';

const BillableForm: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [currentResource, setCurrentResource] = useState<any>(null);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [unitType, setUnitType] = useState<IdLabelData[]>([]);
  const [resourceList, setResourceList] = useState<any[]>([]);
  const [billableFormItems, setBillableFormItems] = useState<any[]>([]);
  const [billableRemovedItems, setBillableRemovedItems] = useState<any[]>([]);

  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [errors, setErrors] = useState({
    name: '',
    price: '',
    unitTypeId: '',
  });

  const validateField = async (element: any) => {
    const elementName = element.name;
    const newErrors: any = {};
    switch (elementName) {
      case 'name':
        if (!element.value.trim()) {
          newErrors.name = 'Name is required.';
        }
        break;
      case 'price':
        if (!element.value.trim()) {
          newErrors.price = 'Price is required.';
        }
        break;
      case 'unitTypeId':
        if (!element.value) {
          newErrors.unitTypeId = 'Unit of measure is required field.';
        }
        break;
    }
    setErrors(newErrors);
    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  interface billableFormFields {
    name: string;

    price: string;
    id?: string | null;

    exclusion: string;
    notes: string;
    items?: any[];
    unitTypeId: any;
  }
  const [billableForm, setBillableForm] = useState<billableFormFields>({
    name: '',
    price: '',
    id: null,
    exclusion: '',
    notes: '',
    unitTypeId: '',
  });

  useEffect(() => {
    if (isInitialLoad.current) {
      if (currentId) {
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
        }
      } else {
        setCurrentRecord(null);
      }
      if (resourceList.length === 0) {
        getResourceList();
      }
      if (unitType.length === 0) fetchUnitTypes();
      isInitialLoad.current = false;
    }
  }, [currentId]);

  const Create = async (dataObj: any) => {
    try {
      const response = await HttpService.post(
        Constants.apiURL + Constants.billableURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        clearForm();
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const Update = async (dataObj: any, id: number) => {
    try {
      dataObj['id'] = id;
      const response = await HttpService.put(
        Constants.apiURL + Constants.billableURL,
        dataObj,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        clearForm();
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const fetchSingleRecord = async (id: any) => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.billableURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const dialogContent = () => {
    return (
      <div className="row mb-3 mt-2">
        <div style={{ width: '600px' }}>
          <SimpleAutoCompleteTextFieldComponent
            name="resourceLstselect"
            value={currentResource}
            isRequired={false}
            errorStr={''}
            keyName="resourceLstselect"
            label="Resource Items"
            onChange={handleBillableChange}
            items={resourceList}
          />
        </div>
        <div className="col">
          <ButtonComponent
            keyName={'addBtn'}
            errors={errors}
            onClick={AddResourceItem}
            label={'Add'}
          />
        </div>
      </div>
    );
  };
  const clearForm = () => {
    setBillableForm({
      name: '',
      price: '',
      id: null,
      exclusion: '',
      notes: '',
      unitTypeId: '',
    });
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    setCurrentRecord(null);
    setBillableRemovedItems([]);
    navigate('/data-management/billable-items');
  };
  const handleRowClick = async (data: any) => {
    console.log(data);
    const record = data.billable;
    setCurrentRecord(record);

    setBillableForm({
      name: record.name,
      price: record.price,
      id: record.id,
      exclusion: record.exclusion,
      notes: record.notes,
      unitTypeId: record.unitTypeId,
    });
    setBillableFormItems(record.details);
  };

  const getResourceList = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.resourcesURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { isActive: '1' }
      );
      if (response.success) {
        const resourceRecords = response.data.paginateRecords;
        if (resourceRecords.length > 0) {
          const updatedArr = resourceRecords.map((item: any) => ({
            ...item,
            label: `${item.name} | ${item.contractorName} | ${item.unit} | ${formatPrice(item.price)}`,
            name: `${item.name}`,
          }));

          setResourceList(updatedArr);
          setCurrentResource(updatedArr[0]);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handleSave = async () => {
    setLoading(true);
    const req: any = {
      name: billableForm.name,
      price: billableForm.price,
      notes: billableForm.notes,
      unitTypeId: billableForm.unitTypeId,
      exclusion: billableForm.exclusion,
      items: billableFormItems,
    };

    if (currentRecord) {
      req['billableRemovedItems'] = billableRemovedItems;
      await Update(req, currentRecord.id);
    } else {
      await Create(req);
    }

    setLoading(false);
  };
  const calculateTotalCost = (newItems: any) => {
    const totalCost = newItems.reduce((acc: number, bItems: any) => {
      return acc + parseInt(bItems.quantity) * parseFloat(bItems.cost);
    }, 0);
    setBillableForm((prev: any) => {
      return { ...prev, price: totalCost };
    });
  };
  const AddResourceItem = () => {
    const index: any = resourceList.findIndex(
      (item) => item === currentResource
    );
    let newItems: any;
    if (index !== -1) {
      setBillableFormItems((prevItems) => {
        newItems = [...prevItems];
        if (!newItems.includes(resourceList[index])) {
          newItems.push(resourceList[index]);
        }

        return newItems;
      });
      calculateTotalCost(newItems);
    }
    setDialogOpen(false);
  };
  const RemoveResourceItem = (index: number) => {
    setBillableFormItems((prevItems) => {
      const newItems = [...prevItems];
      newItems.splice(index, 1);
      calculateTotalCost(newItems);
      return newItems;
    });
    setBillableRemovedItems((prevItems) => {
      const newItems = [...prevItems];
      if (!newItems.includes(billableFormItems[index])) {
        newItems.push(billableFormItems[index]);
      }

      return newItems;
    });
  };
  const handleItemChange = (value: any, index: number, type: string) => {
    setBillableFormItems((prevItems) => {
      // Create a copy of the current state
      const updatedItems = [...prevItems];
      // Update the specific item's property
      updatedItems[index] = { ...updatedItems[index], [type]: value };
      calculateTotalCost(updatedItems);
      return updatedItems;
    });
  };

  const handleDialog = (open: any) => {
    setDialogOpen(open);
  };
  const handleBillableChange = (e: any, dataValue: any) => {
    setCurrentResource(dataValue);
  };
  const hanldebillableFormChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLFormElement
    >
  ) => {
    const { name, value, type } = e.target;
    setBillableForm((prev: any) => {
      const target: any = e.target;
      validateField(target);
      return { ...prev, [name]: value };
    });
  };

  const fetchUnitTypes = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.refBundleURL + '/fetchUnitTypes',
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.data) {
        setUnitType([{ id: '', label: 'Select Unit Type' }, ...response.data]);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const renderResourceItemComponent = () => {
    return (
      <Grid size={12} className="mb-3 mt-3">
        <label key={'lbl_rsrcList'} className="form-label">
          {'Resource Items'}
        </label>
        <TableContainer sx={{ mt: 2 }} component={Paper}>
          <Table>
            <TableHead style={{ background: ' rgba(0, 244, 255, 0.06)' }}>
              <TableRow>
                <TableCell className="boldfont">Resource Items</TableCell>
                <TableCell className="boldfont" style={{ width: '70px' }}>
                  Quantity
                </TableCell>
                <TableCell className="boldfont" style={{ width: '150px' }}>
                  Cost
                </TableCell>
                <TableCell className="boldfont" style={{ width: '100px' }}>
                  UOM
                </TableCell>
                <TableCell
                  className="boldfont"
                  style={{ width: '120px' }}
                  colSpan={2}
                >
                  Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {billableFormItems.map((item: any, index: any) => {
                return (
                  <TableRow>
                    <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                      {item.name}
                    </TableCell>
                    <TableCell>
                      {/* {item.quantity} */}
                      <TextFieldComponent
                        label=""
                        keyName={'qtyFormBillable_' + index}
                        name={'qtyFormBillable_' + index}
                        value={item.quantity}
                        onChange={(event) => {
                          const value = event.target.value;
                          if (value === '' || /^\d+$/.test(value)) {
                            handleItemChange(value, index, 'quantity');
                          }
                        }}
                        errorStr={''}
                        isRequired={false}
                        style={{ width: '60px' }}
                      />
                    </TableCell>
                    <TableCell>
                      {formatPrice(item.cost)}
                      {/* <TextFieldComponent
                        label=""
                        keyName={'costFormBillable_' + index}
                        name={'costFormBillable_' + index}
                        value={item.cost}
                        onChange={(event: any) => {
                          handleItemChange(event.target.value, index, 'cost');
                        }}
                        errorStr={''}
                        isRequired={false}
                        style={{ width: '70px' }}
                      /> */}
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                      {item.unit}
                    </TableCell>
                    <TableCell>
                      {formatPriceSmart(
                        parseFloat(item.cost) * parseInt(item.quantity)
                      )}
                    </TableCell>
                    <TableCell style={{ width: '50px' }}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          RemoveResourceItem(index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow
                onClick={() => {}}
                sx={{
                  '& > *': {
                    borderRight: '1px solid #ddd',
                    height: '45px',
                    borderLeft: '1px solid #ddd',
                    cursor: 'pointer',
                  },
                }}
              >
                <TableCell colSpan={6}>
                  <AddButtonComponent
                    keyName="billableresourcebtn"
                    label="Add Resource Item"
                    onClick={() => {
                      handleDialog(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    );
  };
  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Billable Name',
      value: billableForm.name,
      onChange: hanldebillableFormChange,
      isRequired: true,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Billable Name required' : '')],
    },
    {
      isRequired: true,
      options: unitType,
      label: 'Unit of Measure',
      name: 'unitTypeId',
      value: billableForm.unitTypeId,
      onChange: (e: any) => {
        hanldebillableFormChange(e);
      },
      size: 6,
      type: 'selectField',
      validationRules: [
        (value) => (!value ? 'Unit of Measure is required' : ''),
      ],
    },
    {
      isRequired: false,
      label: '',
      name: '',
      minRows: 7,
      value: '',
      onChange: () => {},
      size: 12,
      customComponent: renderResourceItemComponent(),
      type: 'custom',
    },
    {
      isRequired: false,
      label: 'Internal Notes',
      name: 'notes',
      minRows: 7,
      value: billableForm.notes,
      onChange: hanldebillableFormChange,
      size: 12,
      type: 'textareaField',
    },
    {
      isRequired: false,

      label: 'Billable Descriptions Exclusions',
      name: 'exclusion',
      minRows: 7,
      value: billableForm.exclusion,
      onChange: (e: any) => {
        hanldebillableFormChange(e);
      },
      size: 12,
      type: 'textareaField',
    },
  ];

  return (
    <Stack>
      <CommonForm
        fields={formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={currentId !== 'Add' ? 'Update Billable' : 'Add New Billable'}
        isLoading={loading}
        isUpdate={currentId !== 'Add' ? true : false}
        onSave={handleSave}
        actionButtonPosition="bottom"
      />
      <SimpleDialogComponent
        title={'Resources'}
        dialogContent={dialogContent()}
        open={dialogOpen}
        handleClose={() => {
          handleDialog(false);
        }}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

export default BillableForm;
